<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="home" :loginShow="loginShow" :gotoIndex="gotoIndex" ref="header_child"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> / <span style="color:#2e2e2e">我要预约</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="appointment">
            <el-container>
              <el-header><h2 class="tit8"><span><img src="../../../static/images/guide_sign3.png"> 我要预约</span><em><img src="../../../static/images/required.png"> 为必填项</em></h2></el-header>
              <el-main center="true"><div center="true">
                <el-form  :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
                <table width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab">
                <tr>
                  <td style="width: 310px">
                    <el-form-item  label="受理单位" prop="selectedRegions">
                      <el-cascader v-model="ruleForm.selectedRegion" :props="props" :show-all-levels="false" placeholder="请选择受理单位" @change="onBusiness" clearable style="width: 200px;"></el-cascader>
                    </el-form-item>
                  </td>
                  <td style="width: 310px">
                    <el-form-item  label="预约业务" prop="business">
                      <el-select v-model="ruleForm.business" @change="initData" placeholder="请选择预约业务" style="width:200px">
                        <el-option
                          v-for="(item,index) in dylbOption"
                          :label="item.label"
                          :value="item.value"
                          :key="index">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td >
                    <!--<el-form-item  label="受理单位" prop="partyId">-->
                      <!--<el-select v-model="ruleForm.partyId" @change="onBusiness" placeholder="请选择受理单位" style="width:200px">-->
                        <!--<el-option-->
                          <!--v-for="(item,index) in departOption"-->
                          <!--:label="item.label"-->
                          <!--:value="item.value"-->
                          <!--:key="index">-->
                        <!--</el-option>-->
                      <!--</el-select>-->
                    <!--</el-form-item>-->
                  </td>
                </tr>
                <tr>
                  <td >
                    <el-form-item  label="预约人姓名" prop="name">
                     <el-input v-model="ruleForm.name" placeholder="请输入姓名" clearable maxlength="10" style="width:200px"></el-input>
                    </el-form-item>
                  </td>
                  <td >
                    <el-form-item  label="身份证号" prop="uid">
                      <el-input v-model="ruleForm.uid" placeholder="请输入身份证号" clearable  maxlength="18" style="width:200px"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item  label="联系电话" prop="phone">
                      <el-input v-model="ruleForm.phone" placeholder="请输入联系电话"  clearable maxlength="11" style="width:200px"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                </table>
                </el-form>
                <div v-if="infoFlag" style="font-size: 14px;line-height:30px;width:90%;border-radius: 5px;border: 1px solid #dbdbdb;margin: 0 auto;padding-top: 15px;padding-left: 15px;padding-bottom: 15px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                  <div style="border-bottom:1px solid #dbdbdb;line-height: 40px;font-size: 16px;font-weight: 600; "><span>预约单位信息</span></div>
                  <div style="margin-top: 5px;"><i class="el-icon-phone"></i><span style="margin-left: 5px;">办公电话:</span><span>{{tel}}</span></div>
                  <div><i class="el-icon-add-location"></i><span style="margin-left: 5px;">办公地址:</span><span>{{address}}</span></div>
                  <div><i class="el-icon-warning-outline"></i><span style="margin-left: 5px;">办公说明:</span><span>{{work}}</span></div>
                </div>
                <div v-if="appo" style="font-size:14px;width:90%;border-radius: 5px;border: 1px solid #dbdbdb;margin: 0 auto;padding-top: 15px;padding-left: 15px;padding-bottom: 15px;margin-top: 10px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                  <table align="center" style="width: 60%;border: 1px solid  #dbdbdb;border-bottom: 0px;">
                    <tr v-for="data in dataTimeList">
                      <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 100px;text-align: center">{{data.dutyShowDate}}</td>
                      <td style="border-bottom: 1px solid  #dbdbdb;" v-if="data.windowList && data.windowList.length>0">
                        <div v-for="windowData in data.windowList" style="text-align: center;">
                          <div style="height: 30px;line-height: 30px;background-color: #d7d6d6">{{windowData.windowName}}</div>
                          <div>
                            <table  style="text-align: center;width: 100%;">
                              <tr v-for="timeData in windowData.dataList">
                                <td style="height: 30px;line-height: 30px;"> {{timeData.beginTime}} ~ {{timeData.endTime}}</td>
                                <td>余号:{{timeData.remainingNum}}/{{timeData.sumNum}}</td>
                                <td><el-button size="mini"  @click="convention(windowData.windowId,timeData.atDayType,data.dutyDate)">预约</el-button></td></tr>
                            </table>
                          </div>
                        </div>
                      </td>
                      <td v-else align="center" style="text-align: center;border-bottom: 1px solid  #dbdbdb;height: 30px;line-height: 30px;">
                        --暂无值班信息--
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              </el-main>
            </el-container>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "arrange",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      let _self=this;
      return {
        ruleForm:{
          selectedRegion:[],
          phone:"",
          name:"",
          uid:'',
          business:'',
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          name:[{required:true,message:'请输入您的姓名',tigger:'blur'}],
          uid:[{required:true,validator:this.checkUid,tigger:'blur'}],
          business:[{required:true,message:'请选择要预约的业务',tigger:'change'}],
          phone:[{required:true ,validator:this.checkPhoneNumber,tigger:'blur'}],
        },
        infoFlag:false,
        appo:false,

        tel:'',
        address:'',
        work:'',
        dataTimeList:[],
        dylbOption:[
          { value: 'BLAN', label: '城乡低保' },
          { value: 'CLP_LIV', label: '残疾人生活补贴' },
          { value: 'CLP_HLF', label: '残疾人护理补贴' },
          { value: 'NTF', label: '特困供养' },
          { value: 'TEMP', label: '临时救助' },
          { value: 'BLAN_ORP', label: '事实无人抚养儿童生活费' },
          { value: 'ORP', label: '分散养育孤儿' },
          { value: 'CUTTED', label: '精简退职' },
          { value: 'QYTC', label: '分散养育孤儿' },
          { value: 'ORP', label: '起义投诚' },
        ],
        // selectedRegion:[],
        // departOption:[],
        props: {
          lazy: true,
          checkStrictly:true,
          lazyLoad (node, resolve) {
            const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
                if (response.status === 200 && response.data.code === 200) {
                  const nodes = Object.values(response.data.data).map(function (e) {
                    return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                  })
                  resolve(nodes);
                } else {
                  resolve(nodes);
                }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        applyName:'',
        loginShow:false,
        gotoIndex:false,
      }
    } ,

    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },
      'ruleForm.business'(nv){
        this.appo=false;
        this.infoFlag=false;
      }
    },
    created(){
      this.initArea();
      var userInfo=this.$cookies.get('userInfo')
      if(userInfo && userInfo.userId !='' && userInfo.userId !=-1){
        this.initPerson();
      }
    },
    mounted(){
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
    },
    methods: {
      initPerson(){
        var tttt=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data && response.data.data.isCertification && response.data.data.isCertification=='1'){
              tttt.ruleForm.name=response.data.data.userName;
              tttt.ruleForm.phone=response.data.data.userTel;
              tttt.ruleForm.uid=response.data.data.userIdcard;
            }
          }
        })
      },
      checkPhoneNumber(rule, value, callback) {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
        if (!value) {
          return callback(new Error('请填写手机号码！'))
        } else if (!reg.test(value)) {
          return callback(new Error('请填写正确的手机号码！'))
        }else{
          callback()
        }
      },
      checkUid(rule,value,callback){
        callback(this.$util.func.uid.check(value))
      },
      checkDepartId(rule,value,callback){
        if(!this.ruleForm.selectedRegion || this.ruleForm.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },
      initData(){
        for(var i=0;i<this.dylbOption.length;i++){
          if(this.dylbOption[i].value==this.ruleForm.business){
            this.applyName=this.dylbOption[i].label
            break;
          }
        }
        var partyId =this.ruleForm.selectedRegion[this.ruleForm.selectedRegion.length-1]
        var business =this.ruleForm.business;
        const options={partId:partyId,typeCode:business}
        this.$https.post("/api/appointment/getDutyData.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            this.dataTimeList=response.data.data;
            this.appo=true;
          } else {
            this.dataTimeList =[];
            this.appo=false;
          }
        })
        this.$https.post("/api/appointment/outinformation.do",options,response=>{
          if (response.status === 200 && response.data.code===200  && response.data.data) {
            this.tel=response.data.data.tel;
            this.address=response.data.data.address;
            this.work=response.data.data.work;
            this.infoFlag=true;
          } else {
            this.tel="";
            this.address="";
            this.work="";
            this.infoFlag=false;
          }
        })
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      getDepartAreas(ParentId,index){
        this.ruleForm.partyId=''
        const options={pid:ParentId}
        var t=this;
        this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            t.departOption = Object.values(response.data.data).map(function(e){
              return {label:e.name,value:e.code}
            })
          } else {
            t.departOption =[];
          }
        })
      },
      onBusiness(){
        this.ruleForm.business='';
      },
      //预约保存方法
      convention(windowId,atDayType,dutyDate){
        if(this.loginShow){
          var ttttt=this;
          this.$alert('为了更好的为您服务，预约前请先登录', '登录提示', {
            confirmButtonText: '确定',
            type: 'error'
          }).then(() => {
            // ttttt.loginShow=true;
            // ttttt.loginShow=true;
            // ttttt.loginShow=true;
            // this.loginShow=false;
            ttttt.$refs.header_child.showDia();
            // this.loginShow=true;
          })
          return false;
        }
        // return false;
        var tt=this;
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {

            var _dutyDate=dutyDate.substring(0,4)+"-"+dutyDate.substring(4,6)+"-"+dutyDate.substring(6,8);
            var _dateType="";
            if("am"==atDayType){
              _dateType="上午";
            }else{
              _dateType="下午";
            }
            tt.$confirm('您即将预约'+_dutyDate+_dateType+"【"+tt.applyName+"】业务，请点击【确认】按钮进入预约流程!", '操作提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              tt.setAppointmentYes(windowId,atDayType,dutyDate);
            }).catch(() => {
            });
          } else {
            return false;
          }
        });
      },
      initArea(){
        var areaInfo=this.$cookies.get('areaInfo')
        if(areaInfo && areaInfo.departyId && areaInfo.departyId.length>0){
          this.ruleForm.selectedRegion=areaInfo.departyId;
          //
          // if(areaInfo.provinceId){
          //   this.selectedRegion[0]=areaInfo.provinceId;
          // }
          // if(areaInfo.cityId){
          //   this.selectedRegion[1]=areaInfo.cityId;
          // }
          // if(areaInfo.areaId){
          //   this.selectedRegion[2]=areaInfo.areaId;
          // }
          // if(this.selectedRegion.length>0){
          //   this.getDepartAreas(this.selectedRegion[this.selectedRegion.length-1],0);
          // }
          // if(areaInfo.departyId){
          //   this.ruleForm.partyId=areaInfo.departyId
          // }
        }
      },
      setAppointmentYes(windowId,atDayType,dutyDate){
        var loading = this.$loading({
          lock: true,
          text: '数据处理中,请耐心等待....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var cityId=""
        if (this.ruleForm.selectedRegion[1] && this.ruleForm.selectedRegion[1]!=''){
          cityId=this.ruleForm.selectedRegion[1];
        }
        var areaId=""
        if (this.ruleForm.selectedRegion[2] && this.ruleForm.selectedRegion[2]!='') {
          areaId = this.ruleForm.selectedRegion[2]
        }
        const options={
          peopleName:this.ruleForm.name,
          peopleTel:this.ruleForm.phone,
          partyId:this.ruleForm.selectedRegion[this.ruleForm.selectedRegion.length-1],
          serviceCode:this.ruleForm.business,
          windowId:windowId,
          dateType:atDayType,
          dutyDate:dutyDate,
          peopleIdcard:this.ruleForm.uid,
          cityId:cityId,
          areaId:areaId
        }
        var tt=this;
        this.$https.post("api/appointment/setAppointment.do",options,response=>{
          loading.close();
          if (response.status === 200 && response.data.code===200) {
            if (response.data.data.code == 200) {
              var msg = "";
              msg = msg + "业务名称：" + response.data.data.serviceName + "<br />";
              msg = msg + "预约日期：" + response.data.data.dutyDate + "<br />";
              msg = msg + "预约时段：" + response.data.data.dutyTimeStr + "<br />";
              msg = msg + "咨询电话：" + response.data.data.tel + "<br />";
              msg = msg + "办公地址：" + response.data.data.address + "<br />";
              msg = msg + "预约说明：" + response.data.data.msg + "<br />";
              tt.$alert(msg, "预约成功", {
                type: 'success ',
                confirmButtonText: '确定',
                dangerouslyUseHTMLString:true,
                callback: action => {
                  tt.$router.push('home');
                }
              });
            } else {
              tt.$alert(response.data.data.msg, "预约失败", {
                type: 'error',
                confirmButtonText: '确定',
                callback: action => {
                  tt.initData();
                }
              });
            }
          }else{
            tt.$alert('网络异常，请稍后重试', "预约失败", {
              type: 'error',
              confirmButtonText: '确定',
              callback: action => {
                tt.initData();
              }
            });
          }
        })
      }
    }
  }
</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/suggest/arrange.vue